"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _config = _interopRequireDefault(require("../../config"));
var _analytics = require("../../constants/analytics");
var _AnalyticsModule = require("../../analytics/modules/AnalyticsModule");
var _listingModule = require("../listingModule");
var _termsModule = require("../../terms/termsModule");
var _PublicConnectionSection = _interopRequireDefault(require("./PublicConnectionSection"));
var _InProductConnectionSection = _interopRequireDefault(require("./InProductConnectionSection"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Actions

// Child components

function ConnectionSection(_ref) {
  var isPublic = _ref.isPublic,
    isDisabled = _ref.isDisabled,
    listing = _ref.listing,
    trackInteractionEvent = _ref.trackInteractionEvent,
    inquireListing = _ref.inquireListing,
    trackButtonClick = _ref.trackButtonClick,
    trackLinkClick = _ref.trackLinkClick,
    userPrefs = _ref.userPrefs,
    toggleModal = _ref.toggleModal,
    checkForConnection = _ref.checkForConnection,
    isConnecting = _ref.isConnecting,
    launchTermsAndConditionsModal = _ref.launchTermsAndConditionsModal,
    disconnectFromListing = _ref.disconnectFromListing,
    profile = _ref.profile,
    onConnectListingConnectClick = _ref.onConnectListingConnectClick;
  var listingId = listing.ID,
    _listing$core = listing.core,
    _listing$core2 = _listing$core === void 0 ? {} : _listing$core,
    listingName = _listing$core2.listingName,
    listingType = _listing$core2.listingType,
    _listing$localized = listing.localized,
    _listing$localized2 = _listing$localized === void 0 ? {} : _listing$localized,
    inquireURL = _listing$localized2.inquireURL,
    connectURL = _listing$localized2.connectURL;
  function navigateToListingDeeplink() {
    window.location = "".concat(_config.default.CTEUrl, "?hpo=20&cte=").concat(listingId);
  }
  function handleRequestInformationClick() {
    var elementType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _analytics.elementList.button;
    trackInteractionEvent({
      elementType: elementType,
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.ReqInfo],
      dimensions: {
        listingId: listingId,
        listingName: listingName
      }
    });
    window.open(inquireURL, 'Inquire', 'noopener,noreferrer');
    inquireListing(listingId);
  }

  // this is used only for Joule listings
  function handleSAPStoreButtonClick() {
    var elementType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _analytics.elementList.link;
    trackInteractionEvent({
      elementType: elementType,
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.ReqInfo],
      dimensions: {
        listingId: listingId,
        listingName: listingName
      }
    });
    window.open(connectURL, 'Connect', 'noopener,noreferrer');
  }
  if (isPublic) {
    return /*#__PURE__*/_react.default.createElement(_PublicConnectionSection.default, {
      listingId: listingId,
      listingType: listingType,
      listingName: listingName,
      inquireURL: inquireURL,
      navigateToListingDeeplink: navigateToListingDeeplink,
      handleRequestInformationClick: handleRequestInformationClick
    });
  }
  return /*#__PURE__*/_react.default.createElement(_InProductConnectionSection.default, {
    listing: listing,
    isDisabled: isDisabled,
    trackButtonClick: trackButtonClick,
    userPrefs: userPrefs,
    toggleModal: toggleModal,
    checkForConnection: checkForConnection,
    isConnecting: isConnecting,
    handleRequestInformationClick: handleRequestInformationClick,
    launchTermsAndConditionsModal: launchTermsAndConditionsModal,
    disconnectFromListing: disconnectFromListing,
    trackLinkClick: trackLinkClick,
    profile: profile,
    onConnectListingConnectClick: onConnectListingConnectClick,
    handleSAPStoreButtonClick: handleSAPStoreButtonClick
  });
}
ConnectionSection.propTypes = {
  isPublic: _propTypes.default.bool,
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string.isRequired,
    core: _propTypes.default.shape({
      listingName: _propTypes.default.string,
      listingType: _propTypes.default.string,
      oAuthWorkflowType: _propTypes.default.string,
      clientOptInType: _propTypes.default.string
    }).isRequired,
    localized: _propTypes.default.shape({
      inquireURL: _propTypes.default.string
    }).isRequired
  }).isRequired,
  isDisabled: _propTypes.default.bool,
  trackInteractionEvent: _propTypes.default.func.isRequired,
  inquireListing: _propTypes.default.func.isRequired,
  userPrefs: _propTypes.default.shape({
    companyUUID: _propTypes.default.string
  }).isRequired,
  trackButtonClick: _propTypes.default.func.isRequired,
  trackLinkClick: _propTypes.default.func.isRequired,
  toggleModal: _propTypes.default.func.isRequired,
  checkForConnection: _propTypes.default.func.isRequired,
  isConnecting: _propTypes.default.bool.isRequired,
  launchTermsAndConditionsModal: _propTypes.default.func.isRequired,
  disconnectFromListing: _propTypes.default.func.isRequired,
  onConnectListingConnectClick: _propTypes.default.func.isRequired,
  profile: _propTypes.default.object
};
function mapStateToProps(state) {
  var _state$userProfile;
  return {
    isPublic: state.meta.isPublic,
    userPrefs: state.userPrefs,
    isConnecting: state.listing.isConnecting,
    profile: (_state$userProfile = state.userProfile) === null || _state$userProfile === void 0 ? void 0 : _state$userProfile.profile
  };
}
var mapDispatchToProps = {
  trackInteractionEvent: _AnalyticsModule.interactionEventDispatch,
  inquireListing: _listingModule.inquireListing,
  trackButtonClick: _AnalyticsModule.buttonClickDispatch,
  toggleModal: _listingModule.toggleModal,
  checkForConnection: _listingModule.checkForConnection,
  launchTermsAndConditionsModal: _termsModule.launchTaCModal,
  disconnectFromListing: _listingModule.disconnectListing,
  trackLinkClick: _AnalyticsModule.linkClickDispatch
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConnectionSection);